import { cn } from "../../lib/utils"
import { IconLoader } from "@tabler/icons-react"

function Spinner({ className, stroke = 2, ...props }: React.ComponentProps<typeof IconLoader>) {
  return (
    <IconLoader
      role="status"
      aria-label="Loading"
      className={cn("[width:1rem] [height:1rem] [animation:spin_1s_linear_infinite]", className)}
      stroke={stroke}
      {...props}
    />
  )
}

export { Spinner }
